module.exports = __webpack_public_path__ + "static/media/hu.d1065faa.svg";